import React, { memo, useCallback, forwardRef } from 'react';
import { FlatList } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space } from '@redlink/components/atoms';

export const PreviewPostList = memo(
  forwardRef(
    (
      {
        renderItem: renderItemOrigin,
        // horizontal,
        showsVerticalScrollIndicator,
        ItemComponent,
        contentContainerStyle,
        style,
        separatorSize = 16,
        ref: originRef,
        ...rest
      },
      ref
    ) => {
      const { styles } = useStyle();
      const renderItem = useCallback(
        ({ item, index }) => {
          return ItemComponent({ item });
        },
        [ItemComponent]
      );
      return (
        <FlatList
          style={[styles.container, style]}
          showsVerticalScrollIndicator={false}
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={[
            styles.contentContainer,
            contentContainerStyle,
          ]}
          ItemSeparatorComponent={() => <Space size={separatorSize} />}
          {...{ renderItem, ref }}
          {...rest}
        />
      );
    }
  )
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    flex: 1,
  },
  contentContainer: {
    padding: size.postListPaddingHorizontal,
    paddingBottom: 100,
  },
}));
